"use client";

import { useDebounce } from "@/hooks";
import React, { useState } from "react";
import Search from "./Search";

interface BrandSearchProps {
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
    debounceMs?: number;
}

const BrandSearch: React.FC<BrandSearchProps> = ({
    onChange,
    placeholder = "Search",
    className = "",
    debounceMs = 300,
}) => {
    const [value, setValue] = useState("");

    useDebounce(value, onChange, debounceMs);

    const handleChange = (newValue: string) => {
        setValue(newValue);
    };

    return (
        <Search
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            className={className}
        />
    );
};

export default React.memo(BrandSearch); 